import {createUseStyles} from 'react-jss';

export default createUseStyles({
  addressAsText: {
    width: props => props.inEditDeleteExperiment && '250px',
  },
  fullName: {
    marginBottom: '0.25em',
    fontWeight: props => props.theme.core.boldFontWeight,
  },
  contactNumber: {
    display: 'flex',
    alignItems: 'center',
    color: 'currentcolor',
    marginTop: '0.33em',
  },
  phoneIcon: {
    width: '0.9em',
    height: '0.9em',
    marginRight: '0.3em',
    fill: 'currentcolor',
  },
});
